import { Grid } from "@material-ui/core";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextareaAutosize,
  Tooltip,
} from "@mui/material";
import Controls from "../../../components/controls/Controls";
import AddCustomerForm from "../../../components/forms/addCustomer";
import { Form, useForm } from "../../../components/customHelpers/useForm";
import TextField from "@material-ui/core/TextField";
import Layout from "../../../components/layout/Layout";
import Admin from "../../../components/auth/Admin";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Customer from "../../../actions/customer";
import Order from "../../../actions/order";
import Product from "../../../actions/product";
import { useHistory } from "react-router-dom";
import Notification from "../../../components/customHelpers/Notification";
import Notify from "../../../components/customHelpers/Notify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OrderTable from "./OrderTable";
import { IoMdAdd } from "react-icons/io";
import Popup from "../../../components/customHelpers/Popup";
import CustomerDetails from "./customerDetail";
import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import { updatePrices } from "../../../utils/utils";
import CustomerOrder from "./CustomerOrders";
import { useOrderManagement } from "./useOrderManagement";
const statusLists = ["Ordered", "Pending"];
const initialFValues = {
  editing: false,
};
const AddOrder = () => {
  useEffect(() => {
    getAllCustomers();
    getAllProducts();
  }, []);

  const [products, setProducts] = useState([]);
  const [tempProducts, setTempProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const history = useHistory();
  const [warning, setWarning] = useState("");
  const [remark, setRemark] = useState("");

  const handleChange = (event) => {
    setRemark(event.target.value);
  };

  const [filteredProducts, setFilteredProducts] = useState([]);
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllCustomers } = Customer();
  const { viewAllProductsLists, updateProductList } = Product();
  const { addOrder, viewOrderProducts } = Order();

  const getAllProducts = () => {
    viewAllProductsLists().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.product) {
        setProducts(updatePrices(data.product));
        setTempProducts(updatePrices(data.product));
      }
    });
  };
  const getAllCustomers = () => {
    setValues({ ...values, loading: true });
    viewAllCustomers().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.customers) {
        setValues({
          ...values,
          loading: false,
        });
        setCustomers(data.customers);
      }
    });
  };

  const handleSearchInputChange = (event) => {
    let input = event.target.value;
    if (event) {
      const filtered = products.filter(
        (data) =>
          data.product?.name.toLowerCase().includes(input.toLowerCase()) ||
          data.product?.sku.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  };

  const validate = (fieldValues = values) => {};

  const { values, setValues } = useForm(initialFValues, true, validate);

  const [data, setData] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [productName, setProductName] = useState();
  const [store, setStore] = useState();
  const [sku, setSku] = useState();
  const calculateTotalPrice = () => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2);
    }
  };
  const [customerName, setCustomerName] = useState(null);

  const [paid, setPaid] = useState(0);
  const [discountValue, setDiscountValue] = useState(0);
  const [unpaid, setUnpaid] = useState(0);

  useEffect(() => {
    const totalPrice = calculateTotalPrice();
    setPaid(totalPrice);
    setUnpaid(0);
  }, [data]);

  const [productId, setProdcutId] = useState();
  const [price, setPrice] = useState("");
  const autocompleteRef = useRef(null);

  const [qt, setQt] = useState(0);
  const [quantityError, setQuantityError] = useState(""); // State to manage error message

  const handleChangeQt = (e) => {
    const value = Number(e.target.value);
    if (productQuantity && value > productQuantity) {
      setQuantityError("Quantity exceeds available stock");
    } else {
      setQuantityError("");
    }
    setQt(e.target.value);
  };
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [productQuantity, setProductQuantity] = useState(0);
  const onChangeProductList = (event) => {
    if (event) {
      setProductName(event.product.name);
      setProdcutId(event.id);
      setPrice(event.price);
      setProductQuantity(event.quantity);
      setStore(event.store?.locationName);
      setSku(event.product.sku);

      setSelectedProduct(event);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let orderData = {
      items: data,
      remark: remark,
      paid: unpaid ? paid : calculateTotalPrice(),
      customerID: selectedCustomer,
      status: selectedStatus ? selectedStatus : "Ordered",
      totalPrice: calculateTotalPrice(),
      totalQuantity: data?.reduce(
        (total, list) => total + parseInt(list.quantity),
        0
      ),
    };
    setValues({ ...values, submitting: true });

    addOrder(orderData).then((data) => {
      if (data.err) {
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        history.push(`/orders`);
        NotifyMessage({
          message: "Role successfully created",
          type: "success",
        });
      }
    });
  };
  const handleCache = () => {
    let item;
    const existingProductIndex = data.findIndex(
      (item) => item.product === productId
    );

    const quantityToAdd = Number(qt);

    if (existingProductIndex !== -1) {
      const updatedData = data.map((item, index) =>
        index === existingProductIndex
          ? {
              ...item,
              quantity: item.quantity + quantityToAdd,
              totalPrice: (item.quantity + quantityToAdd) * item.price,
            }
          : item
      );
      item = updatedData;
    } else {
      let totalPrice = quantityToAdd * price;
      if (discount > 0) {
        totalPrice = calculateItemTotal.toFixed(2);
      }
      item = [
        ...data,
        {
          product: productId,
          store: store,
          sku: sku,
          price: price,
          totalPrice: totalPrice,
          quantity: quantityToAdd,
          productName: productName,
        },
      ];
    }

    let orderData = {
      items: item,
      remark: remark,
      paid: unpaid ? paid : calculateTotalPrice(),
      customerID: selectedCustomer,
      status: selectedStatus ? selectedStatus : "Ordered",
      totalPrice: calculateTotalPrice(),
      totalQuantity: data?.reduce(
        (total, list) => total + parseInt(list.quantity),
        0
      ),
    };
    setValues({ ...values, submitting: true });

    addOrder(orderData).then((data) => {
      if (data.err) {
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        history.push(`/orders`);
        NotifyMessage({
          message: "Role successfully created",
          type: "success",
        });
      }
    });
  };

  const updateProductPrice = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    updateProductList({ price: price }, selectedProduct.id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: "Product Price successfully updated",
          type: "success",
        });
        updatePrice(selectedProduct.id, price);
      }
    });
  };
  const updatePrice = (id, newPrice) => {
    setTempProducts((tempProducts) =>
      tempProducts.map((item) =>
        item.id === id ? { ...item, price: newPrice } : item
      )
    );
    setProducts((products) =>
      products.map((item) =>
        item.id === id ? { ...item, price: newPrice } : item
      )
    );
  };
  const saveData = () => {
    if (selectedProduct.price !== price) {
      setConfirmDialog({
        isOpen: true,
        title: "Are you sure to update the inventory price?",
        onConfirm: () => {
          updateProductPrice();
        },
      });
    }
    const existingProductIndex = data.findIndex(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discount)
    );
    const quantityToAdd = Number(qt);
    const existingItem = data.find(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discount)
    );
    if (existingItem) {
      const updatedData = data.map((item, index) =>
        index === existingProductIndex
          ? {
              ...item,
              quantity: item.quantity + quantityToAdd,
              totalPrice:
                discount > 0
                  ? calculateItemTotal.toFixed(2) *
                    (item.quantity + quantityToAdd)
                  : (item.quantity + quantityToAdd) * item.price,
            }
          : item
      );
      setData(updatedData);
    } else {
      let totalPrice = quantityToAdd * price;
      if (discount > 0) {
        totalPrice = calculateItemTotal.toFixed(2);
      }

      setData([
        ...data,
        {
          product: productId,
          discount: discountValue,
          store: store,
          sku: sku,
          price: price,
          totalPrice: totalPrice,
          quantity: quantityToAdd,
          productName: productName,
        },
      ]);
    }
    const updatedProducts = products.map((product) =>
      product.id === productId
        ? { ...product, quantity: product.quantity - quantityToAdd }
        : product
    );
    setProducts(updatedProducts);
    setPrice("");
    setQt(0);
    setProdcutId(null);
    setProductName(null);
    setSelectedProduct(null);
    setInputValue("");
    setDiscount(0);
  };
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer.id);
    setCustomerName(customer);
  };

  const handlePaidChange = (event) => {
    const newPaid = event.target.value;
    if (/^\d*\.?\d*$/.test(newPaid)) {
      setPaid(newPaid);
      const remaining = calculateTotalPrice() - parseFloat(newPaid || 0);
      setUnpaid(remaining);
    }
  };
  const [discount, setDiscount] = useState(0);
  const [isPercentDiscount, setIsPercentDiscount] = useState(false);
  const calculateItemTotal = useMemo(() => {
    if (isPercentDiscount) {
      const totalPriceWithoutDiscount = price * qt;
      const discountAmount = (price * discount * qt) / 100;
      setDiscountValue(discountAmount);
      return totalPriceWithoutDiscount - discountAmount;
    } else {
      setDiscountValue(discount);
      return (price - discount) * qt;
    }
  }, [isPercentDiscount, discount, price, qt]);

  const [selectedStatus, setSelectedStatus] = useState("");

  const handleStatusChange = (e) => {
    setSelectedStatus(e);
  };
  const handleDiscountChange = (e) => {
    const newDiscount = Number(e.target.value);
    setDiscount(newDiscount);
    setWarning("");
    if (isPercentDiscount) {
      if (newDiscount > 100) {
        setWarning("Discount percentage cannot exceed 100%.");
      }
    } else if (newDiscount > price) {
      setWarning("Discount cannot exceed item price.");
    }

    if (isPercentDiscount) {
      const discountAmount = (price * newDiscount) / 100;
      setDiscountValue(discountAmount);
    } else {
      setDiscountValue(newDiscount);
    }
  };

  const { orders, filterOrdersByProductId, groupByStatusAndSumQuantities } =
    useOrderManagement();

  const filteredResults = filterOrdersByProductId(sku);
  const summedResults = groupByStatusAndSumQuantities(filteredResults);
  const overallTotalQuantity = filteredResults?.reduce(
    (total, order) => total + order.totalQuantity,
    0
  );
  return (
    <Layout>
      <Admin>
        <Typography variant="h6">
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/orders");
            }}
          ></ArrowBackIcon>{" "}
          <span style={{ marginLeft: "6px" }}>Order Page</span>
        </Typography>
        {customerName && (
          <Box display="flex" justifyContent="space-between">
            <Box>
              <CustomerDetails customer={customerName} />
            </Box>
            <Box>
              <CustomerOrder id={customerName.id} />
            </Box>
          </Box>
        )}
        <Form onSubmit={handleSubmit}>
          <Grid style={{ marginTop: "20px" }} container spacing={2}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={customers}
                disableClearable
                getOptionLabel={(option) => `${option.fullName}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Customer"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                  />
                )}
                onChange={(event, value) => handleCustomerSelect(value)}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <Controls.Button
                text="Add Customer"
                variant="outlined"
                startIcon={<IoMdAdd />}
                className="newButton"
                onClick={() => {
                  setOpenPopup(true);
                  setRecordForEdit(null);
                  setEdit(false);
                }}
              />
            </Grid>
          </Grid>

          <Notification notify={notify} setNotify={setNotify} />
          <>
            <OrderTable
              productLists={data}
              setData={setData}
              paid={paid}
              setPaid={setPaid}
              setProducts={setProducts}
              tempProducts={tempProducts}
              products={products}
            />
            {products.length > 0 && (
              <Box display="flex" justifyContent="flex-end" m={1} p={1}>
                <Box sx={{ width: "36%" }}>
                  <Autocomplete
                    options={
                      filteredProducts.length === 0
                        ? products.filter((option) => option.quantity > 0)
                        : filteredProducts.filter(
                            (option) => option.quantity > 0
                          )
                    }
                    getOptionLabel={(option) =>
                      `${option.product?.name} - ${option.product?.sku} -  ${
                        option.quantity
                      }  -  ${option.store?.locationName || ""}`
                    }
                    clearOnBlur={true}
                    loading={products.length === 0}
                    ref={autocompleteRef}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search for a Product"
                        variant="outlined"
                        fullWidth
                        onChange={handleSearchInputChange}
                      />
                    )}
                    onInputChange={(event, newInputValue) =>
                      setInputValue(newInputValue)
                    }
                    value={selectedProduct}
                    inputValue={inputValue}
                    onChange={(event, newValue) =>
                      onChangeProductList(newValue)
                    }
                  />
                  {selectedProduct && (
                    <div>
                      {summedResults.length > 0 ? (
                        <>
                          {summedResults.map((result, index) => (
                            <div key={index}>
                              <span>{result.status} - </span>
                              <span>{result.totalQuantity}</span>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div>
                          <div>Orderd: 0</div>
                          <div>Pending : 0</div>
                        </div>
                      )}
                    </div>
                  )}
                </Box>

                <Box p={0}>
                  <TextField
                    id="outlined-basic"
                    value={qt}
                    onChange={handleChangeQt}
                    label="Quantity"
                    fullWidth
                    type="number"
                    variant="outlined"
                    error={Boolean(quantityError)} // Show error state if there's an error message
                    helperText={quantityError} // Display the error message
                  />
                </Box>

                <Box>
                  <TextField
                    id="outlined-basic"
                    value={price}
                    label="Item Price"
                    fullWidth
                    type="number"
                    variant="outlined"
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </Box>
                <Box sx={{ width: "16%" }}>
                  <TextField
                    id="outlined-basic"
                    label="Discount"
                    fullWidth
                    variant="outlined"
                    value={discount}
                    error={!!warning}
                    helperText={warning}
                    onChange={handleDiscountChange}
                  />

                  <FormGroup style={{ marginLeft: "12px" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isPercentDiscount}
                          onChange={(e) =>
                            setIsPercentDiscount(e.target.checked)
                          }
                        />
                      }
                      label="Percent"
                    />
                  </FormGroup>
                </Box>
                <Box>
                  {discount > 0 && calculateItemTotal ? (
                    <TextField
                      id="outlined-basic"
                      value={
                        qt > 0 && price ? calculateItemTotal.toFixed(2) : 0
                      }
                      label="Item Total Price"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  ) : (
                    <TextField
                      id="outlined-basic"
                      value={qt > 0 && price ? price * qt : 0}
                      label="Item Total Price"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  )}
                </Box>

                <Box p={1} sx={{ width: "10%" }}>
                  {qt === 0 ||
                  quantityError ||
                  qt < 0 ||
                  selectedProduct === null ? null : (
                    <Controls.Button
                      text="Add"
                      size="small"
                      variant="outlined"
                      startIcon={<IoMdAdd />}
                      className="Button"
                      onClick={saveData}
                    />
                  )}
                </Box>
              </Box>
            )}
          </>
        </Form>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <TextareaAutosize
            aria-label="minimum height"
            minRows={7}
            placeholder="Remark"
            value={remark}
            onChange={handleChange}
            style={{
              width: 400,
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              resize: "both",
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "column",
              p: 1,
              m: 1,
              bgcolor: "background.paper",
              borderRadius: 1,
            }}
          >
            <Box sx={{ width: "100%", maxWidth: "600px" }} p={1}>
              <Autocomplete
                options={statusLists}
                disableClearable
                getOptionLabel={(option) => `${option}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
                onChange={(event, value) => handleStatusChange(value)}
              />
            </Box>

            {calculateTotalPrice() && (
              <>
                <Box p={1}>
                  <div
                    style={{
                      marginRight: "35px",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    Total Price: {calculateTotalPrice()}
                  </div>
                </Box>

                <Box>
                  <TextField
                    variant="outlined"
                    label="Paid"
                    value={paid}
                    fullWidth
                    type="number"
                    onChange={handlePaidChange}
                    inputProps={{
                      min: "0",
                      title: "Please enter a valid number",
                    }}
                  />
                </Box>
                <Box sx={{ marginTop: 2 }}>
                  <Controls.Input label="Balance" disabled value={unpaid} />
                </Box>
              </>
            )}

            <Box p={1}>
              {productId || selectedProduct ? (
                <Controls.Button
                  disabled={
                    values.submitting ||
                    selectedCustomer === null ||
                    data.length === 0
                      ? true
                      : false
                  }
                  text={values.submitting ? "Adding..." : "Add Order"}
                  variant="contained"
                  className="Button"
                  onClick={() => {
                    setConfirmDialog({
                      isOpen: true,
                      title: "Are you sure to Add this Order?",
                      subTitle: "There is A Product that is not added",
                      onConfirm: () => {
                        handleCache();
                      },
                    });
                  }}
                  type="submit"
                />
              ) : (
                <Controls.Button
                  disabled={
                    values.submitting ||
                    selectedCustomer === null ||
                    data.length === 0
                      ? true
                      : false
                  }
                  text={values.submitting ? "Adding..." : "Add Order"}
                  variant="contained"
                  className="Button"
                  onClick={handleSubmit}
                  type="submit"
                />
              )}
            </Box>
          </Box>
        </Box>
        <Notification notify={notify} setNotify={setNotify} />
        <Popup
          title="Customer Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddCustomerForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setCustomer={setCustomers}
            setCustomerName={setCustomerName}
            fromOrder={true}
            edite={edite}
            setSelectedCustomer={setSelectedCustomer}
          />
        </Popup>
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
          close={handleSubmit}
        />
      </Admin>
    </Layout>
  );
};

export default AddOrder;
